@if (amount !== undefined && amount !== null) {
  <div class="widget">
    <sd-icon class="icon" [type]="iconTypes.BONUS"></sd-icon>
    <span class="amount">
      {{ amount }}
      @if (withWord) {
        {{ +amount | i18nPlural: bonusWordMap }}
      }
    </span>
  </div>
  @if (isPromo) {
    <div class="promo">
      <sd-icon class="promo-icon" [type]="iconTypes.BONUS_PROMO"></sd-icon>
    </div>
  }
}
